import React, { Component } from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import { LabeledText } from '../LabeledText';
import { RadioGroup } from '../RadioGroup';
import { LabeledRadio } from '../LabeledRadio';
import { FieldHelpIcon } from '../../icon/FieldHelpIcon';
import { helpModalControl } from '../../modals/HelpModalControl';
import { helpModalIndex } from '../../modals/helpModalIndex';

class TextMatchSearchCardUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.handleHelpClick = this.handleHelpClick.bind(this);
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.id = `i${uuid()}`;
  }

  handleHelpClick(e) {
    e.preventDefault();
    const { toggleHelpModal, helpModalId } = this.props;
    if (helpModalId) {
      toggleHelpModal(helpModalId);
    }
  }

  render() {
    const {
      children,
      radioGroupModel,
      startsWith,
      includes,
      matches,
      doesNotMatch,
      textModel,
      helpModalId,
    } = this.props;
    let modalConfig = 'Info';
    const tooltip = helpModalIndex[helpModalId];
    if (tooltip !== undefined) {
      if (tooltip.title !== undefined) {
        modalConfig = `${tooltip.title}`;
      }
    }
    return (
      <Card className="haz-inner-card">
        <CardBody>
          <CardTitle>
            <div className="haz-help-icon-inline">
              <span aria-label={modalConfig}>{children}</span>
              {helpModalId && <span><FieldHelpIcon tooltipLabel={helpModalId} handleClick={this.handleHelpClick} /></span>}
            </div>
          </CardTitle>
          <fieldset>
            <legend style={{ display: 'none' }}><span>{children}</span></legend>
            <RadioGroup model={radioGroupModel}>
              <div className="haz-radio-group">
                <div className="haz-radio-group-container">
                  <LabeledRadio model={radioGroupModel} label="Starts With" value={startsWith} />
                  <LabeledRadio model={radioGroupModel} label="Includes" value={includes} />
                  <LabeledRadio model={radioGroupModel} label="Matches" value={matches} />
                  <LabeledRadio model={radioGroupModel} label="Does Not Match" value={doesNotMatch} />
                </div>
              </div>
              <LabeledText name={`${modalConfig} Input`} model={textModel} />
            </RadioGroup>
          </fieldset>
        </CardBody>
      </Card>
    );
  }
}


TextMatchSearchCardUnwrapped.propTypes = {
  children: PropTypes.node.isRequired,
  radioGroupModel: PropTypes.string.isRequired,
  textModel: PropTypes.string.isRequired,
  startsWith: PropTypes.string.isRequired,
  includes: PropTypes.string.isRequired,
  matches: PropTypes.string.isRequired,
  doesNotMatch: PropTypes.string.isRequired,
  toggleHelpModal: PropTypes.func.isRequired,
  helpModalId: PropTypes.string,
};

TextMatchSearchCardUnwrapped.defaultProps = {
  helpModalId: '',
};

export const TextMatchSearchCard = helpModalControl(TextMatchSearchCardUnwrapped);
